<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>租户管理</el-breadcrumb-item>
    </el-breadcrumb>
        <!-- 操作-->

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
            <el-form :inline="true" :model="topForm" ref="topForm">

                <el-form-item prop="name">
                    <el-input v-model="topForm.name" placeholder="租户名称" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="" @click="getData" icon="search":loading="loading">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="add()" >新增</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>
        <!-- 弹窗新增标签-->
        <!--<el-button type="text" >打开嵌套表单的 Dialog</el-button>-->

        <el-dialog title="租户" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
            <el-form  :model="tenantForm" :rules="tenantrules" ref="tenantForm"  >

                <el-form-item label="租户名称" prop="tenantname">
                    <el-input  v-model="tenantForm.tenantname" placeholder="请输入租户名"></el-input>
                </el-form-item>

                <el-form-item label="设备量" prop="deviceAmount">
                    <el-input type="number"  v-model="tenantForm.deviceAmount" placeholder="请输入设备量" :min="0"></el-input>
                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialodclose('tenantForm')">重 置</el-button>
                <el-button type="primary" @click="submitForm('tenantForm')">保存</el-button>
                <!--<el-button type="primary" @click="dialogFormVisible = false">保存</el-button>-->
            </div>
        </el-dialog>


        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;" >
                <el-table-column prop="tenant_id" label="id">  </el-table-column>
                <el-table-column prop="tenant_name" label="租户名称" > </el-table-column>
                <el-table-column prop="user_id" label="登录用户" > </el-table-column>
                <el-table-column prop="update_time" label="更新时间"  :formatter="formatter"  sortable >  </el-table-column>
                <el-table-column label="操作" width="350" >
                    <template scope="scope">
                        <el-button  size="small" @click="tenantEdit(scope.row)"  >编辑</el-button>
                        <el-button  size="small" type="danger"  @click="handleDelete(scope.row)" >删除</el-button>
                        <el-button  size="small" type="info" @click="addRoles(scope.row)" v-if="getcookie('username_client') =='admin'" >绑定登录账户</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>



        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    export  default{
        data(){
            var validateName = (rule, value, callback) => {
                if(this.isable == false) {
                    if (value === '') {
                        callback(new Error('请输入租户名称！'));
                    } else {
                        this.$http.post(this.requetHost+"/sys/tenant/validateName",{name:value}).then(response => {
                            if (response.status === 200) {
                                if (response.body.res === true){
                                    callback(new Error('名称已存在请重新输入！'));
                                }else{
                                    callback();
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                    }
                }else{
                    callback();
                }
            };
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                //参数设置
                url: this.requetHost+"/sys/tenant/findTenantByPage", // 分页查询请求路径
                name: '',
                loading:false,
                isable:false,
                dialogVisible: false,
                /*弹窗选择*/
                dialogFormVisible: false,
                /*弹窗内容选择*/
                topForm:{
                    name:''
                },
                tenantForm:{
                    tenantname:'',
                    deviceAmount:'',
                    id:''
                },
                tenantrules: {
                    tenantname: [
                        {required: true,message: '请输入租户名称', trigger: 'blur'},
                        { validator: this.validatorSpace, trigger: 'blur' },
                        { validator: this.validatorCharmap, trigger: 'blur' },
                        { min: 0, max: 12, message: '长度在 0 到 12 个字符', trigger: 'blur' },
                        { validator: validateName, trigger: 'blur' },

                    ]
                },btnAll:{

                    btn_0441:true,
                    btn_0442:true,
                    btn_0443:true
                }

            }

        },
        created(){
            if(this.getcookie("tenant_id")!="000000"){
                this.updateBtnState("044");
            }

            this.getData();

        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {params:{active:this.activeNum,len:this.pagesize,name:this.topForm.name}};
                //异步请求
                this.$http.get(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.total
                            this.tableData = response.body.data
                            this.loading = false;
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatter(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            handleDelete(row) {
                if(row.tenantname =="admin"){
                    this.$message({showClose: true,message: '系统用户不能删除！',type: 'warning'});
                }else{
                    if(row.tenant_id == this.getcookie('tenant_id')) {
                        debugger;
                        this.$message({showClose: true,message: '对不起！您不能删除自己！',type: 'warning'});
                    }else {
                        this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$store.dispatch('delTenant',row.id).then((data)=>{
                                if(data.res==true){
                                    this.$message({showClose: true,message: '删除成功',type: 'success'});
                                    this.getData();
                                }else{
                                    this.$message({showClose: true,message: data.msg,type: 'error'});
                                }
                            })
                        })
                    }
                }
            },
            add(){
                this.tenantForm.id="";
                this.tenantForm.tenantname="";
                this.dialogFormVisible=true;
                this.isable = false;
            },
            tenantEdit(row){
                this.isable = true;
                this.dialogFormVisible=true;
                this.tenantForm.tenantname=row.name;
                this.tenantForm.id=row.id;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var params={name:this.tenantForm.tenantname,deviceAmount:this.tenantForm.deviceAmount};
                        if(this.id!=""&&this.isable == true){
                            params.id=this.tenantForm.id;
                        }

                        this.$http.post(this.requetHost+"/sys/tenant/saveTenant",params).then(response => {
                            if (response.status === 200) {
                                if (response.body.res === true){
                                    this.$message({showClose: true,message: '保存成功',type: 'success'});
                                    this.getData();
                                }else{
                                    this.$message({showClose: true,message: '参数错误',type: 'error'});
                                }
                            }
                            this.dialogFormVisible=false;
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })

                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            /**--------------------------------------end--------------------------------------------------------**/
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var btnAlllist=new Array("btn_0441","btn_0442","btn_0443");
                    var btnAlllist1=btnAlllist;
                    if(data.length>0) {
                        for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                            for(var j=0;j<btnAlllist.length;j++){
                                if(btnAlllist[j]==btnId){
                                    btnAlllist1.splice(j,1)
                                }
                            } ;
                        }

                    }
                    //隐藏按钮
                    for(var h=0;h<btnAlllist1.length;h++){
                        if(btnAlllist1[h]=="btn_0441"){
                            _this.btnAll.btn_0441=false;
                        }
                        if(btnAlllist1[h]=="btn_0442"){
                            _this.btnAll.btn_0442=false;
                        }
                        if(btnAlllist1[h]=="btn_0443"){
                            _this.btnAll.btn_0443=false;
                        }

                    }
                })
            },
            /**--------------------------------------end--------------------------------------------------------**/
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getData();
            },

            addRoles(row){
                this.savecookie("button", "configUser");
                this.$router.push( {name:"configUser",params:{storeId:row.store_id}})
            },

            dialodclose(formName) {
                this.$refs[formName].resetFields();
            },
        }

    }

</script>


// WEBPACK FOOTER //
// TenantManager.vue?1753f580